import { render, staticRenderFns } from "./ver-pdf-url.vue?vue&type=template&id=f20699aa&"
import script from "./ver-pdf-url.component.ts?vue&type=script&lang=ts&"
export * from "./ver-pdf-url.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports